import { render, staticRenderFns } from "./UpdateDesignCommand.vue?vue&type=template&id=68a4a672&"
import script from "./UpdateDesignCommand.vue?vue&type=script&lang=js&"
export * from "./UpdateDesignCommand.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDesignCommand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports